import React from "react";
import PlanDescription from "./PlanDescription";
import CreditUsage from "./CreditUsage";
import { useNavigate } from "react-router-dom";

function PlanDetails() {
  const navigate = useNavigate();

  const manageSubscription = () => {
    navigate("/pricing");
  };

  const addCredits = () => {
    navigate("/add-credits");
  };

  const checkTransactions = () => {
    navigate("/billing");
  };

  return (
    <div className="container py-12">
      <div className="row">
        <div className="col-12">
          <PlanDescription
            manageSubscription={manageSubscription}
            addCredits={addCredits}
            checkTransactions={checkTransactions}
          />
        </div>
        <div className="col-12 mt-5">
          <CreditUsage />
        </div>
      </div>
    </div>
  );
}

export default PlanDetails;
